/** 기본 제공 점검표 법령명 */
export const LEG_BASIC_DEFAULT_LAW_NM = '산업안전보건법';

/** 점검표 추가 시 선택 옵션 */
export const LEG_BASIC_LAW_SELECT_OPTIONS = [
  {
    id: 'DEFAULT',
    name: LEG_BASIC_DEFAULT_LAW_NM,
    description: '기본 제공되는 산업안전보건법 이행 점검표를 불러옵니다.',
  },
  {
    id: 'NEW',
    name: '신규법령 추가',
    description:
      '전기안전관리법, 위험물관리법, 소방시설법 등 사업장 자체 점검표를 만듭니다.',
  },
];

export const LEG_BASIC_MODAL_APP_TITLE = '안전보건 관계법령 이행 점검';
